































import { Component, Inject, Prop, Vue, Emit } from 'vue-property-decorator';
import { splitColumns, groupLists } from '../../helpers';
import { IMenuItem, IComputedSubMenuData, IGroupedItems, IMenuLink, IPermission, IMenuItemsWrapper } from '../..';
import SecondLevelMenuPanel from './_SecondLevelMenuPanel.vue';
import { NavigationState } from '../../store';
import { namespace } from 'vuex-class';
const navigationState = namespace('NavigationState');

@Component({
    components: {
        SecondLevelMenuPanel
    }
})
export default class TopLevelMenuItem extends Vue {
    private hoverTimeout: any = 0;

    // TODO move this
    @Inject() public events: IMenuItemsWrapper;

    @Prop({ required: true }) public caption: string;
    @Prop({ default: () => [] }) public items: IMenuItem[];
    @Prop({ required: true }) public itemIndex: number | null;

    @navigationState.Getter isSecondLevelOpen: boolean;
    @navigationState.Getter activeTopLevelIndex: number | null;
    @navigationState.Action toggleSecondLevel: () => void;
    @navigationState.Action setActiveTopLevelItem: (itemIndex: number | null) => void;
    @navigationState.Action closeEventsLevel: () => void;

    public get showActiveSecondLevelMenu(): boolean {
        return this.isSecondLevelOpen && this.itemIndex === this.activeTopLevelIndex;
    }

    public toggleSecondLevelPanel(): void {
        this.toggleSecondLevel();

        if (this.isSecondLevelOpen) {
            this.setActiveTopLevelItem(this.itemIndex);
        } else {
            this.setActiveTopLevelItem(null);
        }
    }

    public hoverMenu(): void {
        if (this.hoverTimeout > 0) {
            clearTimeout(this.hoverTimeout);
        }

        this.hoverTimeout = setTimeout(() => {
            if (this.isSecondLevelOpen) {
                this.setActiveTopLevelItem(this.itemIndex);
            }
            this.closeEventsLevel()
        }, 100);
    }

    public hoverLeave(): void {
        clearTimeout(this.hoverTimeout);
    }

    public get menuId(): string {
        return this.caption.replace(/\s/g, '-').toLowerCase().concat('-menu');
    }

    // TODO compute this data at top level
    public get computedSubItems(): [IComputedSubMenuData[], IComputedSubMenuData[]] {
        if (this.events.menuItems) {
            const groupedEvents = groupLists(this.events.menuItems as any);
            this.items.forEach((item) => {
                if (item.type != "GroupHeader" && item.type != "ColumnBreak") {
                    groupedEvents.forEach((event) => {
                        if (event.caption && item.caption && matchEventMenuItem(event, item)) {
                            item.events = event;
                        }
                    });
                }
            });
        }

        return splitColumns(this.items)
            .map(groupLists)
            .filter((x: IComputedSubMenuData[]) => x.length > 0);
    }

    @Emit('navigate') public navigate(e: Event) { return e; }

    public beforeCreate() { NavigationState.register?.(this.$store); }
    public destroyed() { NavigationState.unregister?.(this.$store); }
}

function matchEventMenuItem(eventMenu: IGroupedItems, itemMenu: IMenuLink) {
    const rxDataSipMenu = /data-sip-menu=[\'\"](?<menuId>.*)[\'|\"]/i;
    const menuId = rxDataSipMenu.exec((itemMenu as any)?.html)?.groups?.menuId;
    
    if ((eventMenu as any) !== null && (eventMenu as any).id === menuId) {
        return true;
    } else {
        return eventMenu.caption.toLowerCase() === itemMenu.caption.toLowerCase()
    }
}
